import type { PortalContentKind } from "../../@types/portalAluno";

const PORTAL_CONTENT_KIND_SET: Record<PortalContentKind, true> = {
  "biblioteca-documentos": true,
  "biblioteca-games": true,
  "biblioteca-multimidia": true,
  comunicados: true,
  conteudos: true,
  cursos: true,
  destaques: true,
  "seguranca-do-trabalho": true,
  "treinamentos-de-1-ponto": true,
  trilhas: true,
};

export const PORTAL_CONTENT_KINDS = Object.keys(
  PORTAL_CONTENT_KIND_SET
) as PortalContentKind[];

export const isPortalContentKind = (
  value: unknown
): value is PortalContentKind =>
  typeof value === "string" && value in PORTAL_CONTENT_KIND_SET;
